var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 28,
    rx: 6,
    fill: "url(#paint0_phone)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 28,
    rx: 6,
    fill: "url(#paint1_phone)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 14.654C12.3067 16.8307 14.1693 18.6933 16.346 19.8L18.0227 18.1233C18.2333 17.9127 18.538 17.8427 18.808 17.9313C19.6613 18.2143 20.584 18.3673 21.5413 18.3673C21.9533 18.3673 22.292 18.706 22.292 19.118V21.5413C22.292 21.9533 21.9533 22.292 21.5413 22.292C14.5547 22.292 8.90796 16.6453 8.90796 9.65867C8.90796 9.24667 9.24663 8.908 9.65863 8.908H12.0893C12.5013 8.908 12.84 9.24667 12.84 9.65867C12.84 10.624 12.993 11.5387 13.276 12.392C13.3573 12.662 13.2947 12.9593 13.0767 13.1773L11.2 14.654Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_phone",
    x1: 2,
    y1: 30,
    x2: 30,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00E676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69F0AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_phone",
    x1: 2,
    y1: 2,
    x2: 30,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C853",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E676",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phoneCall.d9c4e7548cfe2669e911cb69773cd3db.svg";
export { ForwardRef as ReactComponent };